import { render } from "./PrettyBar.vue?vue&type=template&id=15267050&scoped=true&ts=true"
import script from "./PrettyBar.vue?vue&type=script&lang=ts"
export * from "./PrettyBar.vue?vue&type=script&lang=ts"

import "./PrettyBar.vue?vue&type=style&index=0&id=15267050&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15267050"]])

export default __exports__